import { render } from "./DonateCheckout.vue?vue&type=template&id=13ae3794"
import script from "./DonateCheckout.vue?vue&type=script&lang=js"
export * from "./DonateCheckout.vue?vue&type=script&lang=js"
script.render = render

export default script